import { isNodeV2 } from '@vedalib/editor'
import * as R from 'ramda'

import { updateBlock } from 'services/Store/Project/actions'
import { toggleDone } from 'services/Store/Project/mutators/node'
import { getBlock, getSelectedNodeIds } from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'
import store from 'services/Store/store'

export const onLock = () => {
  const dispatch = store.dispatch
  const state = store.getState().project
  const block = getBlock(state)
  const selectedNodes = getSelectedNodeIds(state)
  const children = selectedNodes
    .map((id) => block?.schema.nodes[id])
    .filter(isNodeV2)
    .filter((node) => !node.elementId)

  if (block) {
    dispatch(
      updateBlock({
        id: block?.uuid,
        value: R.compose(...(children.map(toggleDone) as [(block: Block) => Block]))(block),
      }),
    )
  }
}
